@if (publish) {
  <div class="progress-container">
    @if (publish.Progress === 0) {
      <div class="message">
        Checking database... This may take a moment.
      </div>
    }
    @if (publish.FileSyncProgress === 0 && publish.Progress === 25) {
      <div class="message">
        Checking files... This may take a moment.
      </div>
    }
    <div class="progress">
      @if (publish.Progress > 0) {
        <div class="percentage">
        {{ publish.Progress }}%</div>
      }
      @if (publish.Progress > 0) {
        <div class="progress-bar"
        [ngStyle]="{ width: publish.Progress + '%' }"></div>
      }
    </div>
  </div>
}